import { Icon } from "./Icon.tsx";

/** A bent line with a dot at each vertex, matching the vertex-handle
 * circles this toggle gates (NetworkMap.tsx). Deliberately not a 4-way
 * move cross — that read as "pan mode" rather than "edit this shape's
 * points" in testing. */
export function EditGeometryIcon() {
  return (
    <Icon>
      <path d="M4 20 L10 10 L20 6" />
      <circle cx="4" cy="20" r="1.6" fill="currentColor" stroke="none" />
      <circle cx="10" cy="10" r="1.9" fill="currentColor" stroke="none" />
      <circle cx="20" cy="6" r="1.6" fill="currentColor" stroke="none" />
    </Icon>
  );
}
